<div class="chat-input-container">
  <div class="input-wrapper">

    <div appMaxChars [maxChars]="maxChars" appDisableCopy
      #maxCountDir="appMaxChars" (click)="onInputDoubleClick($event)" (charCount)="onCharCount($event)"
      (maxCharLimitReached)="handleCharLimit($event)" #messageBox sabisHighlightMathSelection class="chat-input-field math-larger"
      [class.landing]="isLandingPage" (beforeinput)="onBeforeInput($event)"
      [attr.contenteditable]="isConnectionEstablished && (hasActiveSession && !isOutOfPrompts) ? 'true' : null"
      data-placeholder="Ask SABIS LUMI." (keydown)="onKeyDown($event)" (input)="onInputChange()"
      (paste)="onPaste($event)" (drop)="onDrop($event)">
    </div>

    <div class="input-separator"></div>

    <div class="inline-button-container">
      @if (canAddEquation) {
      <button class="inline-equation-button" (click)="openEquationModal()"
        [disabled]="!isConnectionEstablished || isOutOfPrompts || !hasActiveSession || showWarning">
        <img src="assets/icons/attach-icon.png" alt="Send Button" width="17" height="20" />
        <span>Add Equation</span>
      </button>
      }

       @if (isChatbotModeActive) {
      <div class="chatbot-mode-toggle">
        @for (mode of chatbotModes; track mode.code) {
        <button class="mode-toggle-button" [class.active]="chatbotModeCode === mode.code" (click)="setChatbotModeCode(mode.code)" [disabled]="isChatInProgress">
          {{ mode.name }}
        </button>
        }
      </div>
      }

      @if (isChatInProgress) {
      <button (click)="onStopSending()" class="inline-send-button stop-button" aria-label="Stop">
        <!-- <img src="assets/icons/stop-icon.png" alt="Stop Button" width="16" height="16" /> -->
      </button>
      } @else {
      @if (isMessageNotEmpty && isConnectionEstablished && !isOutOfPrompts && !isOverMaxChars) {
      @if (isEditingMessage) {
      <button (click)="onCancelEdit()" class="inline-cancel-edit-button" aria-label="Cancel">
        Cancel
      </button>
      }
      <button (click)="onSendMessage()" class="inline-send-button" aria-label="Send">
        <img src="assets/icons/send-icon.png" alt="Send Button" width="25" height="22" />
      </button>
      } @else {
      <button class="inline-send-button disabled-button" aria-label="Send">
        <img src="assets/icons/send-icon-disabled.png" alt="Send Button" width="25" height="22" />
      </button>
      }
      }

    </div>

  </div>

  <div class="counter-warning-row">
    @if (isOverMaxChars) {
    <div class="warning overflow-warning">Please shorten your message to a maximum of {{ maxChars }} characters.</div>
    } @else if (showWarning) {
    <div class="warning">That's all for now - {{ maxChars }} Characters used!</div>
    } @else {
    <span></span>
    }
    @if (showCounter) {
    <div class="char-counter" [class.over-limit]="isOverMaxChars">{{ userMessageLength }} / {{ maxChars }}</div>
    }
  </div>

  <div class="disclaimer-message">{{ disclaimerMessage }}</div>
</div>

<!-- equation dialog -->
<app-modal [isVisible]="showEquationModal" [showCloseButton]="false" (userKeydown)="onEquationKeyDown($event)"
  (closeModal)="closeEquationModal()">

  <!-- equation editor -->
  <app-equation-editor #equationEditor [equation]="equationValue" (onKeyDown)="onEquationKeyDown($event)"
    [readOnly]="false"></app-equation-editor>

  <div class="chatbot-modal-footer">
    @if (!isNetworkOnline) {
    <span class="connection-loss-message">Looks like you have lost connection. Please try again later.</span>
    }
    <button (click)="confirmEquationModal()" [disabled]="isConfirmDisabled || !isNetworkOnline">Ok</button>
    <button (click)="closeEquationModal()">Close</button>
  </div>

</app-modal>